import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Packages
import { Button, Col, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Components
import OrgFilters from '../../filters/OrgFilters';
import SchemasFormModal from './SchemasFormModal';
import SchemasTable from './SchemasTable';
import StatusUpdate from '../../utils/StatusUpdate';

// Actions
import { get_all_self_schemas, self_schema_status_update } from '../../../redux/actions/selfSchemasActions';
import { get_load_status_desc } from '../../../utils/get_status_desc';
import { get_load_status_color } from '../../../utils/get_color_status';

const Schemas = (props) => {
	const { messageApi } = props;

	const { t } = useTranslation();

	const dispatch = useDispatch();

	const { isAdminUser } = useSelector(state => state.auth);

	const { self_schema_status_history_loading, self_schema_status_history } = useSelector(state => state.self_schemas);

	const [orgFilters, setOrgFilters] = useState({ organization: '', workspace: '', module: '' });
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [update, setUpdate] = useState(false);
	const [schemaToUpdate, setSchemaToUpdate] = useState({});
	const [openStatusUpdate, setOpenStatusUpdate] = useState(false);
	const [pageSize] = useState(0);
	const [skip, setSkip] = useState(0);

	// Note: isAdminUser was removed from condition to prevent request with empty filters before OrgFilters restores values from localStorage
	useEffect(() => {
		if (orgFilters.organization !== '') {
			const filters = { ...orgFilters, skip: 0, limit: 0 };
			dispatch(get_all_self_schemas(filters));
		}
	}, [orgFilters]);

	const createSchema = () => {
		setIsModalOpen(true);
		setUpdate(false);
		setSchemaToUpdate({});
	}

	const closeStatusUpdateModal = () => {
		setSchemaToUpdate({});
		setOpenStatusUpdate(false);
	}

	const changeSchemaStatus = (status) => {
		const schemaFilters = { ...orgFilters, skip: 0, limit: 0 };
		dispatch(self_schema_status_update(messageApi, schemaToUpdate?._id?.$oid, status, schemaFilters, closeStatusUpdateModal));
	}

	return (
		<Row justify='center'>
			<Col lg={24} md={24} sm={24} xs={24}>
				<StatusUpdate
					openModal={openStatusUpdate}
					handleCancel={closeStatusUpdateModal}
					loadingHistory={self_schema_status_history_loading}
					statusHistory={self_schema_status_history}
					statusDescriptions={(status) => get_load_status_desc(status)}
					statusColors={(status) => get_load_status_color(status)}
					statusQty={9}
					changeStatus={(status) => changeSchemaStatus(status)}
				/>

				<SchemasFormModal
					messageApi={messageApi}
					isModalOpen={isModalOpen}
					setIsModalOpen={setIsModalOpen}
					orgFilters={orgFilters}
					update={update}
					schemaToUpdate={schemaToUpdate}
					setSchemaToUpdate={setSchemaToUpdate}
					pageSize={pageSize}
					skip={skip}
				/>

				<Row justify='center'>
					<Col lg={8} md={8} sm={24} xs={24}></Col>
					<Col lg={8} md={8} sm={24} xs={24}>
						<Typography.Title className='text-center' level={2}>{t('schemas.title')}</Typography.Title>
					</Col>
					<Col style={{ textAlign: 'end' }} lg={8} md={8} sm={24} xs={24}>
						<Button
							type='primary'
							size='large'
							onClick={() => createSchema()}
						>
							{t('loadForm.create.title').split(' ')[0]}
						</Button>
					</Col>
				</Row>

				<Row justify='center'>
					<Col lg={17} md={17} sm={24} xs={24}>
						<OrgFilters
							orgFilters={orgFilters}
							setOrgFilters={setOrgFilters}
							displayFilters={{ organization: true, workspace: true, module: true }}
						/>
					</Col>
				</Row>

				<SchemasTable
					messageApi={messageApi}
					orgFilters={orgFilters}
					setIsModalOpen={setIsModalOpen}
					setUpdate={setUpdate}
					setSchemaToUpdate={setSchemaToUpdate}
					setOpenStatusUpdate={setOpenStatusUpdate}
					pageSize={pageSize}
					skip={skip}
					setSkip={setSkip}
				/>
			</Col>
		</Row>
	);
}

Schemas.propTypes = {
	messageApi: PropTypes.object.isRequired
}

export default Schemas;
